import { SB } from '@play-co/replicant';

// How much real money user has spent
export const lifetimeValue = SB.int();

export const checkoutProductId = SB.string();
